export enum RelationshipType {
    UNKNOWN,
    CHILD,
    FRIEND,
    SIBLING,
    PARENT,
    PARTNER
}